import MarketingManagement from "../components/marketing-management";


function MarketingManagementPage() {
  return <MarketingManagement/>;
}

export default MarketingManagementPage;
